export default __webpack_public_path__ + "static/media/aks.959257f1.jpeg";